// extracted by mini-css-extract-plugin
export default {"imageContainer":"HorizontalScrollSlider_imageContainer__pUHua","image":"HorizontalScrollSlider_image__4wjFd","title":"HorizontalScrollSlider_title__dDxlb"};